import { getPercent } from '@systemeio/util'

export const getPercentAndAmountStatistic = ({
  numberOfActions = 0,
  totalNumber = 0,
}: {
  numberOfActions?: number
  totalNumber?: number
}) => {
  return `${getPercent(numberOfActions, totalNumber)}% (${numberOfActions})`
}
